import { render, staticRenderFns } from "./ximeiSelectedService.vue?vue&type=template&id=cbdb62fa&scoped=true&"
import script from "./ximeiSelectedService.vue?vue&type=script&lang=js&"
export * from "./ximeiSelectedService.vue?vue&type=script&lang=js&"
import style0 from "./ximeiSelectedService.vue?vue&type=style&index=0&id=cbdb62fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb62fa",
  null
  
)

export default component.exports